export default function ArticleImage({ src, alt = '', className = '', imgClassName = '', loading }) {
  return (
    <div
      className={`relative select-none ${className}`}
      onContextMenu={(e) => e.preventDefault()}
      data-testid="article-image-protected"
    >
      <img
        src={src}
        alt={alt}
        draggable={false}
        loading={loading}
        className={`pointer-events-none ${imgClassName}`}
        style={{ WebkitUserDrag: 'none', userSelect: 'none' }}
      />
      <span
        className="absolute bottom-2 right-2 text-[10px] font-bold tracking-[0.2em] text-white/80 bg-black/35 px-1.5 py-0.5 rounded pointer-events-none select-none"
        data-testid="article-image-watermark"
      >
        powerx
      </span>
    </div>
  );
}
